<template>
  <div class="charge-record">
    <div class="head">
      <el-radio-group class="select-tab" v-model="selectedTab" @change="toUrl">
        <el-radio-button label="收费登记"></el-radio-button>
        <el-radio-button label="收费表单"></el-radio-button>
      </el-radio-group>
    </div>
    <div class="search">
      <el-form
        :model="exportForm"
        ref="exportForm"
        label-width="100px"
        class="demo-ruleForm"
        hide-required-asterisk
      >
          <el-form-item class="serviceContent" prop="serviceContent" label="所属服务项：">
            <div
              :class="{serviceContentActive: index === activeIndex}"
              v-for="(item, index) in serviceContentList"
              :key="item.id"
              @click="clickServiceContent(item.id, index)"
            >
              {{ item.name }}
            </div>
          </el-form-item>
        <div class="orther-search">
          <div class="orther-search-title">其他筛选项：</div>
          <div class="orther-search-main">
            <el-form-item class="warehouse-name" prop="warehouseId" label="仓库：">
              <el-select
                class="gray white w200"
                v-model="exportForm.warehouseId"
                placeholder="请选择仓库"
              >
                <el-option
                  v-for="item in warehouse"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="project-name" prop="userName" label="货主名称：">
              <el-select
                class="gray white w200"
                v-model="exportForm.userName"
                placeholder="请选择货主"
                @change="changeUserName"
                filterable
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="project-name" prop="projectName" label="项目名称：">
              <el-select
                class="gray white w200"
                v-model="exportForm.projectName"
                placeholder="请选择项目"
              >
                <el-option
                  v-for="item in projectNameList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="warehouse-name" prop="date" label="时间：">
              <el-date-picker
                class="w240"
                v-model="exportForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item v-if="exportForm.serviceContent === 1" class="project-name" prop="expressCode" label="物流单号：">
              <el-input
                class="gray white"
                v-model="exportForm.expressCode"
                placeholder="请填写物流单号"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="checked">
              <el-checkbox class="check w200" :class="{activeCheck: exportForm.serviceContent === 1}" v-model="exportForm.checked"
                >展示作废记录</el-checkbox
              >
            </el-form-item>
            <el-form-item>
              <el-button class="btn-blue" @click="searchData">搜索</el-button>
              <el-button @click="cancelExportForm('exportForm')"
                >清空</el-button
              >
              <el-button
                type="primary"
                class="btn-blue"
                @click="exportLoginForm('exportForm')"
                >导出</el-button
              >
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName">
        <el-table-column
          v-for="(item, index) in tableTitle"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          v-if="exportForm.serviceContent === 2"
          prop="goodsInfo"
          label="商品信息"
          min-width="120"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" placement="top">
              <div v-html="scope.row.goodsInfoStr" slot="content"></div>
              <div class="oneLine">{{scope.row.goodsInfo}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          v-if="exportForm.serviceContent === 2"
          prop="nums"
          label="数量"
        >
        </el-table-column>
        <el-table-column
          v-if="exportForm.serviceContent === 2"
          prop="unitPrice"
        >
          <template slot="header">
            <el-tooltip class="item" effect="dark" placement="top" ref="returnObj">
              <div v-html="ToBreak(returnObj.returnStr)" slot="content"></div>
              <div>
                单价
                <img class="question-mark" src="../../../../assets/images/charge-record/question-mark.png">
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          v-if="exportForm.serviceContent === 2"
          prop="amount"
          label="金额"
        >
        </el-table-column>
        <el-table-column
          v-if="exportForm.serviceContent === 2"
          prop="statusVal"
          label="状态"
        >
        </el-table-column>
        <el-table-column
          v-if="exportForm.serviceContent === 1||exportForm.serviceContent === 3"
          label="备注"
          min-width="150"
        >
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.remarks" placement="top">
              <p class="remarks">{{ scope.row.remarks }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status !== 1" class="btn-text" type="text" @click="nullify(scope.row.id)"
              >作废</el-button
            >
            <el-button v-else class="btn-text nullify" type="text" disabled
              >作废</el-button
            >
            <el-button v-if="exportForm.serviceContent == 2 && scope.row.statusCopy < 3 && scope.row.statusCopy" class="btn-text" type="text" @click="finish(scope.row.id)"
              >入库完成</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>
  </div>
</template>

<script>
import Expenses from "models/expenses";
import Logistics from "models/logistics";
import ChargeRegister from "models/charge-register";
const expenses = new Expenses();
const logistics = new Logistics();
import PaginationTpl from "components/base/PaginationTpl";
import { modifyNetTitle } from "common/js/util";
export default {
  components: {
    PaginationTpl,
  },

  data() {
    return {
      selectedTab: '收费表单',
      activeIndex: 0,
      total: 0,
      currentPage: 1,
      pageSize: 20,
      warehouse: [],
      customerList: [],
      projectNameList: [],
      serviceContentList: [],
      tableData: [],
      tableTitle: [
        {label: '仓库', prop: 'warehouseName', width: ''},
        {label: '日期', prop: 'creatTime', width: '100'},
        {label: '货主名称', prop: 'customersName', width: '120'},
        {label: '项目名称', prop: 'projectName', width: '120'},
        {label: '承运商', prop: 'expressName', width: '120'},
        {label: '目的地', prop: 'address', width: '120'},
        {label: '系统单号', prop: 'systemCode', width: '120'},
        {label: '物流单号', prop: 'expressCode', width: '120'},
        {label: '重量', prop: 'weight', width: ''},
        {label: '数量', prop: 'nums', width: ''},
        {label: '单价', prop: 'unitPrice', width: ''},
        {label: '金额', prop: 'amount', width: ''},
      ],
      exportForm: {
        warehouseId: "",
        date: "",
        userName: "",
        projectName: "",
        expressCode: '',
        serviceContent: 1,
        checked: false,
      },
      returnObj: {
        returnStr: ''
      },
      returnStatusObj: {
        1: '待开单',
        2: '待入库',
        3: '入库完成'
      }
    };
  },

  created() {
    modifyNetTitle('收费表单')
    this.getWarehouse();
    this.getCustomerList();
    this.getServiceContent();
    this.initChargeRegister();
  },
  mounted() {
  },

  methods: {
    /* 将 \n 换为 <br/>标签 */
    ToBreak (val) {
      if (val) {
        return val.replace('\n', '<br />')
      }
    },
    /* 翻页 */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initChargeRegister();
    },
    initChargeRegister() {
      let warehouseId	 = this.exportForm.warehouseId
      let expressCode = this.exportForm.expressCode
      let beginDate	 = this.exportForm.date[0]
      let endDate	 = this.exportForm.date[1]
      let customerId	 = this.exportForm.userName
      let projectId	 = this.exportForm.projectName
      let isCancel	 = this.exportForm.checked?1:0
      let currentPage	 = this.currentPage
      let data = {
        warehouseId,
        beginDate,
        endDate,
        customerId,
        projectId,
        isCancel,
        currentPage,
      }
      if (this.exportForm.serviceContent === 1) {
        let dataServiceContent = {
          warehouseId,
          beginDate,
          endDate,
          customerId,
          projectId,
          isCancel,
          currentPage,
          expressCode,
        }
        this.initBulkList(dataServiceContent)
      } else if (this.exportForm.serviceContent === 2) {
        this.initRefundList(data)
      } else if (this.exportForm.serviceContent === 3) {
        this.initUnloadingList(data)
      } else if (this.exportForm.serviceContent === 4) {
        this.initLabelList(data)
      }
    },
    /* 大宗出库登记记录列表 */
    initBulkList(data) {
      ChargeRegister.getChargeRecordBulkList(data).then((res) => {
        if (res.success) {
          let arr = [];
          this.total = res.result.totalNum
          res.result.items.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.warehouseName = value.warehouseName;
            obj.weight = value.weight;
            obj.creatTime = value.billDate;
            obj.customersName = value.customerName;
            obj.projectName = value.projectName;
            obj.status = value.isCancel;
            obj.nums = value.checkNum;
            obj.unitPrice = value.unitPrice;
            obj.amount = value.checkPrice;
            obj.remarks = value.remarks;
            obj.expressName = value.expressName;
            obj.address = value.address;
            obj.systemCode = value.systemCode;
            obj.expressCode = value.expressCode;
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      });
    },
    /* 退货服务登记记录列表 */
    initRefundList(data) {
      ChargeRegister.getChargeRecordRefundList(data).then((res) => {
        if (res.success) {
          let arr = [];
          this.total = res.result.totalNum
          res.result.items.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.warehouseName = value.warehouseName;
            obj.creatTime = value.billDate;
            obj.customersName = value.customerName;
            obj.projectName = value.projectName;
            obj.status = value.isCancel;
            obj.nums = value.checkNum;
            obj.unitPrice = value.unitPrice;
            obj.amount = value.checkPrice;
            obj.expressCode = value.expressCode;
            obj.sender = value.sender;
            obj.goodsName = value.goodsName;
            obj.statusCopy = value.status;
            obj.statusVal = this.returnStatusObj[value.status];
            obj.validDate = value.validDate;
            let str = ''
            let str2 = ''
            value.checkRecordRefundGoodsList.map(i => {
              str += `${i.goodsName}，商品${i.quantity}件， <span style="color: red;">次品${i.badQuantity}件</span>，${i.goodsBarCode}，${i.validDate}；`+`<br />`
              str2 += `${i.goodsName}，商品${i.quantity}件， 次品${i.badQuantity}件，${i.goodsBarCode}，${i.validDate}；`
            })
            obj.goodsInfoStr = str
            obj.goodsInfo = str2
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      });
    },
    /* 卸货服务登记记录列表 */
    initUnloadingList(data) {
      ChargeRegister.getChargeRecordUnloadingList(data).then((res) => {
        if (res.success) {
          let arr = [];
          this.total = res.result.totalNum
          res.result.items.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.warehouseName = value.warehouseName;
            obj.creatTime = value.billDate;
            obj.customersName = value.customerName;
            obj.projectName = value.projectName;
            obj.status = value.isCancel;
            obj.nums = value.checkNum;
            obj.unitPrice = value.unitPrice;
            obj.amount = value.checkPrice;
            obj.remarks = value.remarks;
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      });
    },
    /* 贴标服务登记记录列表 */
    initLabelList(data) {
      ChargeRegister.getChargeRecordLabelList(data).then((res) => {
        if (res.success) {
          let arr = [];
          this.total = res.result.totalNum
          res.result.items.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.warehouseName = value.warehouseName;
            obj.creatTime = value.billDate;
            obj.customersName = value.customerName;
            obj.projectName = value.projectName;
            obj.status = value.isCancel;
            obj.nums = value.checkNum;
            obj.serviecName = value.extraServiceName;
            obj.unitPrice = value.unitPrice;
            obj.amount = value.checkPrice;
            obj.goodsCode = value.goodsCode;
            obj.goodsName = value.goodsName;
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      });
    },
    /* 为 Table 中的某一行添加 class */
    tableRowClassName({row}) {
      if (row.status !== 1) {
        return '';
      }
      return 'active';
    },
    /* 获取仓库数据 */
    getWarehouse() {
      expenses.getWarehouseData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouse = arr;
          this.exportForm.warehouseId = this.warehouse[0].id;
        }
      });
    },
    /* 获取货主名称 */
    getCustomerList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
        }
      });
    },
    changeUserName() {
      let customerId, warehouseId;
      customerId = this.exportForm.userName;
      warehouseId = "";
      this.getProjectNameList(customerId, warehouseId);
    },
    /* 获取项目名称 */
    getProjectNameList(customerId, warehouseId) {
      ChargeRegister.getProjectList(customerId, warehouseId).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.projectsName;
            obj.returnStr = `超件退货价格：${value.refundPriceRules.unit_price}`+
            `\n`+`退货件数范围：${value.refundPriceRules.quantity_limit}`+
            `\n`+`超件退货价格：${value.refundPriceRules.excess_unit_price}`
            arr.push(obj);
          });
          this.projectNameList = arr;
          if (this.projectNameList.length === 0) {
            this.exportForm.projectName = "";
            setTimeout(() => {
              let returnStr = `超件退货价格：`+
              `\n`+`退货件数范围：无`+
              `\n`+`超件退货价格：`
              this.$set(this.returnObj, 'returnStr', returnStr)
              this.$refs.returnObj.$refs.popper.innerText = returnStr
            },100)
          } else {
            this.exportForm.projectName = this.projectNameList[0].id;
            if (this.exportForm.serviceContent === 2) {
              // setTimeout(() => {
                let refundPriceRules = res.result[0].refundPriceRules
                let returnStr = `超件退货价格：${refundPriceRules.unit_price}`+
                `\n`+`退货件数范围：${refundPriceRules.quantity_limit}`+
                `\n`+`超件退货价格：${refundPriceRules.excess_unit_price}`
                this.$set(this.returnObj, 'returnStr', returnStr)
                this.$refs.returnObj.$refs.popper.innerText = returnStr
              // },100)
            } else {
              setTimeout(() => {
                let refundPriceRules = res.result[0].refundPriceRules
                let returnStr = `<span>超件退货价格：${refundPriceRules.unit_price}</span>`+
                `<br />`+`<span>退货件数范围：${refundPriceRules.quantity_limit}</span>`+
                `<br />`+`<span>超件退货价格：${refundPriceRules.excess_unit_price}</span>`
                this.$set(this.returnObj, 'returnStr', returnStr)
                this.$refs.returnObj.$refs.popper.innerText = returnStr
              },100)
            }
          }
        }
      });
    },
    /* 获取服务内容 */
    getServiceContent() {
      ChargeRegister.getServiceList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.serviceContentList = arr;
        }
      });
    },
    cancelExportForm(formName) {
      this.$refs[formName].resetFields();
    },
    /* 导出 */
    exportLoginForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId	 = this.exportForm.warehouseId
          let beginDate	 = this.exportForm.date[0]
          let endDate	 = this.exportForm.date[1]
          let customerId	 = this.exportForm.userName
          let projectId	 = this.exportForm.projectName
          let isCancel	 = this.exportForm.checked?1:0
          let currentPage	 = this.currentPage
          let expressCode = this.exportForm.expressCode
          let data
          if (this.exportForm.serviceContent === 1) {
            data = {
              warehouseId,
              beginDate,
              endDate,
              customerId,
              projectId,
              isCancel,
              currentPage,
              expressCode
            }
          } else {
            data = {
              warehouseId,
              beginDate,
              endDate,
              customerId,
              projectId,
              isCancel,
              currentPage,
            }
          }
          ChargeRegister.getExport(data, this.exportForm.serviceContent).then((res) => {
            let blob = new Blob([res.data], { type: res.headers.contentType });
            let fileName = window.decodeURI(
              res.headers["content-disposition"].split("=")[1]
            );
            var url = URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            a.click();
            // 释放之前创建的URL对象
            window.URL.revokeObjectURL(url);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /* 搜索 */
    searchData() {
      this.currentPage = 1;
      this.initChargeRegister();
    },
    nullify(id) {
      this.$confirm("是否确认作废该条记录？", "作废", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "messageBox",
        confirmButtonClass: "btn-blue",
        cancelButtonClass: "btn-white",
      }).then(() => {
        let data = {
          id
        }
        ChargeRegister.postNullify(data, this.exportForm.serviceContent).then(res => {
          if (res.success) {
            this.initChargeRegister();
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
      });
    },
    finish(id) {
      this.$confirm("是否确认该条数据入库完成？", "入库完成", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "messageBox",
        confirmButtonClass: "btn-blue",
        cancelButtonClass: "btn-white",
      }).then(() => {
        ChargeRegister.postFinish(id).then(res => {
          if (res.success) {
            this.initChargeRegister();
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
      });
    },
    toUrl(v) {
      if (v === '收费表单') {
        this.$router.push({
          path: '/service/charge-index/charge-record'
        })
      } else {
        this.$router.push({
          path: '/service/charge-index/charge-register'
        })
      }
    },
    clickServiceContent(id, index) {
      this.currentPage = 1;
      this.activeIndex = index
      this.exportForm.serviceContent = id
      let arr
      if (id === 3) {
        arr = [
          {label: '仓库', prop: 'warehouseName', width: ''},
          {label: '日期', prop: 'creatTime', width: '100'},
          {label: '货主名称', prop: 'customersName', width: '120'},
          {label: '项目名称', prop: 'projectName', width: '120'},
          {label: '数量', prop: 'nums', width: ''},
          {label: '单价', prop: 'unitPrice', width: ''},
          {label: '金额', prop: 'amount', width: ''},
        ]
      } else if (id === 1) {
        arr = [
          {label: '仓库', prop: 'warehouseName', width: ''},
          {label: '日期', prop: 'creatTime', width: '100'},
          {label: '货主名称', prop: 'customersName', width: '120'},
          {label: '项目名称', prop: 'projectName', width: '120'},
          {label: '承运商', prop: 'expressName', width: '120'},
          {label: '目的地', prop: 'address', width: '120'},
          {label: '系统单号', prop: 'systemCode', width: '120'},
          {label: '物流单号', prop: 'expressCode', width: '120'},
          {label: '重量', prop: 'weight', width: ''},
          {label: '数量', prop: 'nums', width: ''},
          {label: '单价', prop: 'unitPrice', width: ''},
          {label: '金额', prop: 'amount', width: ''},
        ]
      } else if (id === 2) {
        arr = [
          {label: '仓库', prop: 'warehouseName', width: ''},
          {label: '日期', prop: 'creatTime', width: '100'},
          {label: '货主名称', prop: 'customersName', width: '120'},
          {label: '项目名称', prop: 'projectName', width: '120'},
          {label: '运单号', prop: 'expressCode', width: '120'},
          {label: '寄件人', prop: 'sender', width: '120'},
        ]
      } else if (id === 4) {
        arr = [
          {label: '仓库', prop: 'warehouseName', width: ''},
          {label: '日期', prop: 'creatTime', width: '100'},
          {label: '货主名称', prop: 'customersName', width: '120'},
          {label: '项目名称', prop: 'projectName', width: '120'},
          {label: '商品条码', prop: 'goodsCode', width: '140'},
          {label: '商品名称', prop: 'goodsName', width: '120'},
          {label: '数量', prop: 'nums', width: '100'},
          {label: '服务名称', prop: 'serviecName', width: '152'},
          {label: '单价', prop: 'unitPrice', width: '100'},
          {label: '金额', prop: 'amount', width: ''},
        ]
      }
      this.tableTitle = arr
      if (this.exportForm.serviceContent === 2) {
        if (!this.exportForm.projectName) {
          setTimeout(() => {
            let returnStr = `超件退货价格：`+
            `\n`+`退货件数范围：无`+
            `\n`+`超件退货价格：`
            this.$set(this.returnObj, 'returnStr', returnStr)
            this.$refs.returnObj.$refs.popper.innerText = returnStr
          },150)
        }
      }
      this.initChargeRegister()
    },
  },
};
</script>

<style lang='scss'>
.charge-record {
  flex: 1;
  .oneLine {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .question-mark {
    width: 14px;
    height: 14px;
    margin-left: 6px;
  }
  .head {
    flex: 1;
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 400;
    background: #f2f4f8;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .search {
    padding: 32px 37px 25px 37px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    .demo-ruleForm {
      .orther-search {
        display: flex;
        justify-content: flex-start;
        .orther-search-main {
          flex: 1;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
        }
        .orther-search-title {
          font-size: 14px;
          line-height: 32px;
          text-align: left;
        }
        .el-form-item {
          display: flex;
        }
      }
      .warehouse-name {
        .el-form-item__label {
          width:90px !important;
        }
        .el-form-item__content {
          margin-left: 0px !important;
        }
      }
      .project-name {
        .el-form-item__label {
          width: 90px !important;
        }
        .el-form-item__content {
          margin-left: 0px !important;
        }
      }
      .row {
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
      .serviceContent {
        width: 100%;
        border-bottom: 1px solid #eee;
        padding-bottom: 24px;
        .el-form-item__label {
          text-align: left;
        }
        .el-form-item__content {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-left: 30px!important;
          div {
            padding: 0px 8px;
            margin-right: 30px;
            cursor: pointer;
          }
        }
        .serviceContentActive {
          border-radius: 4px;
          background: #2E68EA;
          color: #fff;
        }
      }
      .el-form-item__content {
        margin-left: 0px !important;
      }
      .el-checkbox__input.is-checked + .el-checkbox__label,
      .el-checkbox__label {
        color: #666;
      }
      .el-input {
        width: 200px;
      }
    }
    .w200 {
      width: 200px;
    }
    .w240 {
      width: 240px;
      margin-right: 16px;
    }
    .check {
      width: 308px;
      box-sizing: border-box;
      margin-left: 50px;
    }
    .activeCheck {
      margin-left: 40px;
    }
    .el-select {
      margin-right: 16px;
    }
  }
  .table {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    .el-table {
      .el-table__body-wrapper {
        .el-table__body {
          .active {
            .tr,td {
              .cell {
                color:#AAAAAA;
              }
            }
          }
        }
      }
      .cell {
        position: relative;
        .remarks {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-right: 14px;
        }
        .icon {
          position: absolute;
          right: 1px;
          top: 9px;
          cursor: pointer;
        }
      }
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
  .el-button.nullify {
    color: #AAAAAA;
  }
  .remarks {
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
}
</style>
